module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight--dark-b5f3f68083ab77983abcc55778ef7754.png";